import { AbstractService } from 'src/services/AbstractService';
import { config } from 'src/lib/config';
import { ServiceError } from 'src/lib/errors';

interface CreateDesignPersonalizationContextRequest {
    strategies: Array<{
        strategy: string;
        data: string;
    }>;
}

interface CreateDesignPersonalizationContextResponse {
    designPersonalizationContextId?: string;
    // Full DPC object for display
    [key: string]: any;
}

class DpcmServiceApi extends AbstractService {
    public async createDesignPersonalizationContext(
        accessToken: string,
        canonicalId: string,
        request: CreateDesignPersonalizationContextRequest,
        signal?: AbortSignal,
    ): Promise<CreateDesignPersonalizationContextResponse> {
        const url = `${this.version}/context`;

        const searchParams = new URLSearchParams({
            persistContext: 'true',
            canonicalId,
            requestor: config.appName,
        });

        try {
            const httpResponse = await this.api.post(url, {
                json: request,
                searchParams,
                signal,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            // Handle 204 No Content - document has no DPC
            if (httpResponse.status === 204) {
                return {};
            }

            const response = await httpResponse.json() as CreateDesignPersonalizationContextResponse;

            return response;
        } catch (e: any) {
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to create design personalization context',
                info: (e as Error).message,
                url,
                canonicalId,
            });
        }
    }
}

export const DpcmService = new DpcmServiceApi(config.services.dpcmServiceApi);
